import axios from 'axios';
import StoreModal from './StoreModal';
import ProductDetailPage from './ProductDetailPage';

export default class GlobalStoreHelper {
    static debugger = false
    static debugHour = null // Set to a number (0-23) to simulate a specific hour, or null to use real time
    static debugMinutes = null // Set to a number (0-59) to simulate specific minutes, or null to use real time
    static storage = mmkt.core.storage

    static debug(msg){
        if(!GlobalStoreHelper.debugger) return
        if(!Array.isArray(msg)) msg = [msg]
        msg.map(m => console.log('[ Store Selector - Debugger ]', m))
    }

    static settings(key) {
        const keys = {
            serverUrl: window.mmkt.config.API.ecommerce,
            locations: 'storeSelector.locations',
            onlineStore: 'storeSelect.onlineStore',
            configKey: 'storeSelector.configItems',
            locationId: 'storeSelector.locationId',
            cachedStockKey: 'storeSelector.cachedStock',
            checkoutMismatch: 'storeSelector.checkoutMismatch',
            firstLoadKey: 'storeSelector.firstLoadKey'
        }
        return key ? keys[key] : keys
    };

    static getItem(key) {
        const item = GlobalStoreHelper.storage.getItem(GlobalStoreHelper.settings(key));

        if (item === null) return null;
        if (item === 'true') return true;
        if (item === 'false') return false;

        const num = Number(item);
        if (!isNaN(num)) return num;

        try {
            return JSON.parse(item);
        } catch (e) {
            return item;
        }
    }

    static setItem(key, value, cache) {
        const cacheTime = 20
        GlobalStoreHelper.storage.setItem(GlobalStoreHelper.settings(key), value, typeof cache === 'boolean' ? cacheTime : cache);
    }

    static async getToken(){
        return await mmkt.core.oauth.getToken({ client_id: 'storeSelector', client_secret: 'yuYYeHFl92S4gjnpe90fl3f7' });
    }

    static async request({ service, method, body, cache } = {}){
        const cacheTime = 20
        const cacheName = cache ? service : null

        // Return from cache
        if(cache && GlobalStoreHelper.storage.getItem(cacheName)) return GlobalStoreHelper.storage.getItem(cacheName);

        const { data, status } = await axios({
            method: method || 'GET',
            baseURL: `${GlobalStoreHelper.settings('serverUrl')}/${ service }`,
            headers: { 'Authorization': 'JWT ' + await GlobalStoreHelper.getToken() },
            ...(body && { data: body })
        })

        if(cache && status === 200) GlobalStoreHelper.storage.setItem(cacheName, data, typeof cache === 'boolean' ? cacheTime : cache);
        return data
    }

    /**
     * Retrieve settings from localStorage and parse the JSON. If expiration time has not been reached, return the object,
     * otherwise, fetch new object info and update localStorage with new value. Simple localStorage caching mechanism.
     * @param key string which must be extracted from localStorage
     * @param url string URL for GET path on API to re-populated outdated info in localStorage
     */
    static async retrieveSettingsOrRefetch(key, url) {
        const value = GlobalStoreHelper.getItem(key);
        let response = null;

        if (!value) {
            const { data } = await axios.get(url);
            GlobalStoreHelper.setItem(key, data);
            response = data;
        } else {
            const parsed = JSON.parse(value);
            const currDate = new Date();
            if (new Date(parsed.fetchedAt) < currDate.setHours(currDate.getHours() - 1)) {
                localStorage.removeItem(settings[key]);
                return await GlobalStoreHelper.retrieveSettingsOrRefetch(key, url);
            }
            response = parsed;
        }

        return response;
    }

    /**
     * Performs check for store names in localStorage and currently selected store
     * Afterwards populates HTML DOM field on Product Detail Page
     */
    static setProperStoreNameOnPDP({ storeInfo  = null } = {}) {
        const body = document.getElementsByTagName('body')[0];
        if (!body || !body.classList.contains('template-product')) return;

        if(storeInfo){
             // In case store delivery is disabled, abort
            const storeNameDiv = document.querySelector('.store-location #store-name');
            if (!storeNameDiv) {
                const showBackInStock = document.querySelector('#instock');

                showBackInStock.style.display = 'block';
                return;
            }
            storeNameDiv.innerHTML = storeInfo.name;
        };
        ProductDetailPage.outputStockInfo(storeInfo);
    }

    /**
     * Retrieves correct store name and updates it in the header
     */
    static async setProperStoreNameInHeader({ storeInfo = null } = {}) {
        if(!storeInfo) return;
        const headerMobileBtn = document.querySelector('.store-selector-mobile #store-selector-trigger');
        const headerBtn = document.querySelector('#store-selector-trigger');

        if (headerBtn) {
            headerBtn.querySelector('.store-name').innerHTML = storeInfo.name;
        }
        if (headerMobileBtn) {
            headerMobileBtn.querySelector('.store-name').innerHTML = storeInfo.name;
        }
    }

    static updateStoreNames() {
        const storeInfo = GlobalStoreHelper.getStoreInfo();
        GlobalStoreHelper.setProperStoreNameInHeader({ storeInfo });
        GlobalStoreHelper.setProperStoreNameOnPDP({ storeInfo });
    }

    /**
     * Tries to retrieve cached version of product stock information or fetch it from API
     * @returns object with stock information for specific product
     */
    static async getCachedStock(shopifyProductId = null) {
        const productForm = document.querySelector('#AddToCartForm .speed-pickup');
        const selectQty =  document.querySelector('.quantity_wanted_p select#Quantity');
        const requestedQty = selectQty && Number(selectQty.options[selectQty.selectedIndex].value || 1);

        if (!productForm && !shopifyProductId) return GlobalStoreHelper.getItem('cachedStockKey')
        let stock = {};

        const productId = shopifyProductId || productForm.dataset.id;

        // TODO: Caching disabled
        // stock = JSON.parse(localStorage.getItem(settings.cachedStockKey));
        // if (!stock || !stock[productId]) {
            const data = await GlobalStoreHelper.request({ service: `products/${productId}/stock-at-locations` })
            stock = {};
            stock[productId] = data;
            // localStorage.setItem(settings.cachedStockKey, JSON.stringify(stock));
        // }
        stock[productId] = stock[productId].map((product) => ({...product, requestedQty}));

        return stock[productId];
    }

    /**
     * Retrieve setting values defined on the backend of the app and store them on
     * class instance
     * @return {void}
     */
    static async getConfigItems() {
        let configItems = GlobalStoreHelper.getItem('configKey');

        if (!configItems) {
            const { docs } = await GlobalStoreHelper.request({ service: `settings/?application=store-selector`, cache: true })
            configItems = Object.fromEntries(
                docs.map((conf) => [conf.keyName, conf.valueName])
            );
            GlobalStoreHelper.setItem('configKey', configItems);
        }

        return configItems;
    };

    static async fetchAndInitDefaultStore() {
        let locationId = GlobalStoreHelper.getItem('locationId')

        // if (!storeInfo[locationId]) {
            let response;
            if (!locationId) {
                const { location } = await StoreModal.getGPSCoords();
                const data = await GlobalStoreHelper.request({ service: `locations/pickups/closest`, method: 'POST', body: {
                    latitude: location.lat,
                    longitude: location.lng,
                }, cache: true })
                locationId = data.location.locationId;
                response = this.updateStoreInfo(data.location)
            }
            GlobalStoreHelper.setItem('firstLoadKey', true);
        // }
    }

    static combineAddress(location) {
        if (!location) return '';

        const address = [];
        if (location.address1) address.push(location.address1);
        if (location.address2) address.push(location.address2);
        if (location.city) address.push(location.city);
        if (location.zip) address.push(location.zip);
        return address.join('<br>');
    }

    static formatDate(date) {
        let d = new Date(date);

        // If the date string ends with 'Z', it's UTC and should be treated as such
        let month, day, year;
        if (typeof date === 'string' && date.endsWith('Z')) {
            month = '' + (d.getUTCMonth() + 1);
            day = '' + d.getUTCDate();
            year = d.getUTCFullYear();
        } else {
            month = '' + (d.getMonth() + 1);
            day = '' + d.getDate();
            year = d.getFullYear();
        }

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    /**
     * Format information from backend so it can be re-used for promise generation logic
     * @param locationBasedObject
     * @returns {*[]}
     */
    static formatBatchPromiseRequest(locationBasedObject) {
        const keys = Object.keys(locationBasedObject);
        const locationsMix = [];

        for (let i = 0; i < keys.length; i++) {
            const locationProducts = locationBasedObject[keys[i]];

            locationProducts.sort((a, b) => a.quantity >= b.quantity);

            locationProducts.forEach((location) => {
                locationsMix.push({
                    ...location,
                    locationId: keys[i],
                    storeDelivery: location.isPhysicalStore,
                })

            })
        }

        return locationsMix;
    }

    /**
     * Checks on the appropriate label based on set tags on the product and applies correct promise dates.
     * Returns object for further formatting in PDL and PDP
     * @param {array<object>} items Object
     * @param {Object} options locationId = null, smallDate = false, addStoreSelector = false, storeSelectorModal = false, productId = null
     * @returns {{online: {}, store: {}}}
     */
    static async createPromiseObject(items, options= {}) {
        items = items.sort((a , b) => a?.requestedQty > b?.requestedQty ? -1 : 1);

        const promisesKey = options?.isModal ? "MODAL" : (window.location.href.includes("collections") || window.location.href.includes("search-results-page")) ? "PLP" : "PDP"
        const locations = GlobalStoreHelper.getItem('locations')
        const locationId = GlobalStoreHelper.getItem('locationId')
        const selectedLocationInfo = locations && locations[options.locationId] ? locations[options.locationId].settings : null
        const locIsWareHouse15 = options.locSelectedIsWarehouse15 !== undefined ? options.locSelectedIsWarehouse15 : (selectedLocationInfo && selectedLocationInfo.wareHouse15);
        const requestedQty = items[0]?.requestedQty || null;
        const onlineLoc = (await GlobalStoreHelper.request({ service: `locations/settings?isPhysicalStore=false&isLongtailLocation=false`, cache: true }))[0]

        GlobalStoreHelper.debug(['=== createPromiseObject START ===', {
            promisesKey,
            locationId,
            selectedLocationInfo,
            locIsWareHouse15,
            requestedQty,
            options,
            items
        }])

        const defaultOptions = {
            cartPage: false,
            locationId: null,
            smallDate: false,
            skipDate: false,
            newLine: true,
            addStoreSelector: true,
            appendStoreName: false,
            storeSelectorModal: false,
            productId: null,
            isPLP: false,
            warehouseTag: true,
            peninsulaStockTag: false,
            isReleaseUnknow: false,
            noEnvioTag: false
        }
        const defKeys = Object.keys(defaultOptions);
        for (let i = 0; i < defKeys.length; i++) {
            const receivedOptKeys = Object.keys(options);
            if (receivedOptKeys.indexOf(defKeys[i]) === -1) {
                options[defKeys[i]] = defaultOptions[defKeys[i]];
            }
        }
        const newLineTag = options.newLine ? '<br />' : '';

        let storeSelectorHtml = `
            ${options.appendStoreName ? ' - ' : '<br />'}
            ${options.appendStoreName ? '<span>'+ (locations && locations[locationId]?.name?.replace('MediaMarkt ', '') || '') +'</span>' : ''}
            <a href="javascript:;" class="plp-store-selector" onClick="storePickup.storeModal.toggleStoreSelector(${options.productId});">
            (${window.promises.select_other_location})
            </a>
        `;

        if (!options.addStoreSelector) {
            storeSelectorHtml = '';
        }

        let results = {
            online: {
                message: options.cartPage ? window.promises.shipping_title : null,
                date: new Date().setFullYear(2100),
                color: 'grey',
                code: 1
            },
            store: {
                message: null,
                date: new Date().setFullYear(2100),
                color: 'grey',
                code: 2
            },
        };

        const online = items.find((item) => item.onlineStore);
        const store = items.find((item) => !item.onlineStore && (parseInt(options.locationId) ? parseInt(item.locationId) === parseInt(options.locationId) : true));
        const storeDeliveries = items.filter((item) => !item.onlineStore && item.isPhysicalStore && (item.quantity > 0 || item?.deliverable));
        const availabilityInStores = items.filter((item) => !item.onlineStore && (item.quantity > 0 || item?.deliverable));

        GlobalStoreHelper.debug(['=== Items Found ===', {
            online,
            store,
            storeDeliveriesCount: storeDeliveries.length,
            availabilityInStoresCount: availabilityInStores.length
        }]);

        if (online.presaleDate || online.receiveDate || online.reserveDate) {
            const dateString = this.formatDate(online.presaleDate || online.receiveDate || online.reserveDate);
            // Set default messages for PDP and Cart
            results.online = {
                message: options.skipDate ? window.promises.presale_no_date : window.promises.presale_msg_for_online.replace(
                  '{{ date }}',
                  newLineTag + (options.smallDate ? '<small>' : '') + dateString + (options.smallDate ? '</small>' : '')
                ),
                date: online.presaleDate || online.receiveDate || online.reserveDate,
                color: 'green',
                code: 3
            };

            results.store = {
                message: options.skipDate ? window.promises.presale_no_date : window.promises.presale_msg_for_store.replace(
                    '{{ date }}',
                    newLineTag + (options.smallDate ? '<small>' : '') + dateString + (options.smallDate ? '</small>' : '')
                ) + storeSelectorHtml,
                date: online.presaleDate || online.receiveDate || online.reserveDate,
                color: 'green',
                code: 4
            };

            // Override with custom format for PLP - smaller messages
            if (options.isPLP) {
                // Adjust message for online deliveries
                results.online = {
                    message: options.skipDate ? window.promises.presale_no_date : window.promises.presale_msg_for_online.replace(
                      '{{ date }}',
                      newLineTag + (options.smallDate ? '<small>' : '') + dateString + (options.smallDate ? '</small>' : '')
                    ),
                    date: online.presaleDate || online.receiveDate || online.reserveDate,
                    color: 'green',
                    code: 5
                };
                results.store = {
                    message: options.skipDate ? (window.promises.other_pickup + storeSelectorHtml) : window.promises.presale_msg_for_store.replace(
                        '{{ date }}',
                        newLineTag + (options.smallDate ? '<small>' : '') + dateString + (options.smallDate ? '</small>' : '')
                    ) + storeSelectorHtml,
                    date: online.presaleDate || online.receiveDate || online.reserveDate,
                    color: 'green',
                    code: 6
                };
            }
        } else if (online.isDeliveryDateTBD || online.isReleaseDateTBD || options.isReleaseUnknow) {

            results.online = {
                message: window.promises.release_delivery,
                date: new Date().setFullYear(2100),
                color: 'orange',
                code: 7
            };

            results.store = {
                message: window.promises.release_pickup,
                date: new Date().setFullYear(2100),
                color: 'orange',
                code: 8
            };
        } else {
            // Default pickup message when out of stock everywhere
            results.store.message = window.promises.not_available;

            // There is still stock in other stores
            if ((availabilityInStores.length > 0 || store?.otherLocations > 0) && !options.storeSelectorModal) {
                const clickableMessage = `<a href="javascript:;" class="plp-store-selector text-underline" onClick="storePickup.storeModal.toggleStoreSelector(${options.productId});">${window.promises.check_availability_link}</a>`;
                const pdpMessage = `<a href="javascript:;" class="plp-store-selector text-underline" onClick="storePickup.storeModal.toggleStoreSelector();">${window.promises.check_in_other_stores}</a>`;
                results.store = {
                    pdpMessage: pdpMessage,
                    labelOnly: true,
                    message: clickableMessage,
                    color: 'orange',
                    code: 9
                };
            }

            function getDates(stringWithDates) {
                if(!stringWithDates) return {};

                if (typeof stringWithDates === 'number' ) return {
                    start: window.promises_settings.min,
                    end: stringWithDates
                };

                const days = stringWithDates.split('-');

                if(days.length >= 2)
                    if(parseInt(days[0]) > parseInt(days[1]))
                        return {};
                    else
                        return {
                            start: parseInt(days[0]),
                            end: parseInt(days[1])
                        };
                 else if(days.length === 1)
                    return {
                        start: window.promises_settings.min,
                        end: parseInt(days[0])
                    };
                else return {};
            }

            const { start: onlineStartDate, end: onlineEndDate } = getDates(online?.deliveryDays);
            const { start: storeStartDate, end: storeEndDate } = getDates(store?.deliveryDays);

            GlobalStoreHelper.debug(['=== Delivery Days ===', {
                onlineDeliveryDays: online?.deliveryDays,
                onlineStartDate,
                onlineEndDate,
                storeDeliveryDays: store?.deliveryDays,
                storeStartDate,
                storeEndDate
            }]);

            let disableDeliveryTag = false;

            // If delivery days are defined, we never disable
            if (!store?.deliveryDays) {
                if ((!locIsWareHouse15 && !options.peninsulaStockTag) || (!locIsWareHouse15 && options.warehouseTag)) {
                    disableDeliveryTag = true;
                }
            }

            let expressDeliveryDays = !disableDeliveryTag && storeEndDate;
            let minExpressDeliveryDays = 0;
            let openSoon = false;
            // Separate calculations for online and store delivery dates
            let minDeliveryOnline = onlineStartDate || window.promises_settings.min;
            let maxDeliveryOnline = onlineEndDate || window.promises_settings.max;
            let minDeliveryStore = storeStartDate || window.promises_settings.min;
            let maxDeliveryStore = storeEndDate || window.promises_settings.max;

            GlobalStoreHelper.debug(['=== Initial Delivery Ranges ===', {
                minDeliveryOnline,
                maxDeliveryOnline,
                minDeliveryStore,
                maxDeliveryStore
            }]);

            // Create an array with the exception of the store
            const locationInfo = locations && locations[options?.locationId ? options.locationId : locationId] ? locations[options?.locationId ? options.locationId : locationId].settings : null
            const storeExceptions = locationInfo?.exceptionDates || [];
            if(!locationInfo) return

            // Get current time in Canary Islands timezone (Atlantic/Canary)
            const canaryTime = new Date().toLocaleString('en-US', { timeZone: 'Atlantic/Canary' });
            const canaryDate = new Date(canaryTime);

            // Get current hours and minutes (or use debug values if set)
            const currentHour = GlobalStoreHelper.debugHour !== null ? GlobalStoreHelper.debugHour : canaryDate.getHours();
            const currentMinutes = GlobalStoreHelper.debugMinutes !== null ? GlobalStoreHelper.debugMinutes : canaryDate.getMinutes();
            const currentDate = canaryDate.getDate();

            GlobalStoreHelper.debug(['⏰ CANARY ISLANDS TIME ⏰', {
                browserTime: new Date().toISOString(),
                canaryTime: canaryDate.toISOString(),
                canaryTimeStr: canaryTime,
                currentHour,
                currentMinutes,
                currentDate,
                isDebugMode: GlobalStoreHelper.debugHour !== null || GlobalStoreHelper.debugMinutes !== null,
                debugHour: GlobalStoreHelper.debugHour,
                debugMinutes: GlobalStoreHelper.debugMinutes
            }]);

            // Get weekday holidays
            const holidays = [];

            let dayOpenFound = false;

            for (let i = 1; i <= 7; i = i + 1) {
                holidays.push((onlineLoc[`start${i}`] === '00:00' && onlineLoc[`end${i}`] === '00:00') || (!onlineLoc[`start${i}`] && !onlineLoc[`end${i}`]));

                if(minExpressDeliveryDays < 0 || openSoon) continue;

                // Today day
                let todayDay = new Date().getDay();

                // Set Sunday as 7 day
                todayDay = todayDay === 0 ? 7 : todayDay;

                // If we are iterating a the current day or the ones after it
                if(i >= todayDay && !dayOpenFound) {
                    // Start/End hours and minutes of iterated working day
                    let [startHour, startMinutes] = locationInfo[`start${i}`] ? locationInfo[`start${i}`].split(':') : [];

                    let [endHour, endMinutes] = locationInfo[`end${i}`] ? locationInfo[`end${i}`].split(':') : [];

                    // If start hour and end hour are 00 then that day store is closed
                    let isClosed = startHour === '00' && endHour === '00';

                    // Check if the day is a holiday/exception
                    const holiday = storeExceptions.find((exception) => {
                        // Create date to check by adding offset days to today (using Canary time)
                        const dateToCheck = new Date(canaryDate);
                        dateToCheck.setDate(dateToCheck.getDate() + (i - todayDay));
                        dateToCheck.setHours(0, 0, 0, 0);

                        // Parse exception date manually to avoid timezone issues
                        // Format: "2025-11-28" -> [2025, 11, 28]
                        const [year, month, day] = exception.date.split('-').map(Number);
                        const exceptionDate = new Date(year, month - 1, day, 0, 0, 0, 0);

                        // Simple date comparison - just check if dates match (same day)
                        const matches = dateToCheck.getTime() === exceptionDate.getTime();

                        GlobalStoreHelper.debug(['=== Exception Date Comparison ===', {
                            iterationDay: i,
                            todayDay,
                            currentDate,
                            offset: i - todayDay,
                            dateToCheck: dateToCheck.toISOString(),
                            dateToCheckTime: dateToCheck.getTime(),
                            exceptionTitle: exception.title,
                            exceptionDateStr: exception.date,
                            parsedYMD: [year, month, day],
                            exceptionDate: exceptionDate.toISOString(),
                            exceptionDateTime: exceptionDate.getTime(),
                            matches
                        }]);

                        return matches;
                    });

                    if(!!holiday) {
                        // If it's a full-day holiday, mark as closed and skip
                        if(holiday.isFullDayHoliday) {
                            isClosed = true;
                            minExpressDeliveryDays++;
                            continue;
                        }

                        // If not a full-day holiday, use the exception's special hours instead of regular hours
                        if(holiday.startTime && holiday.endTime) {
                            [startHour, startMinutes] = holiday.startTime.split(':');
                            [endHour, endMinutes] = holiday.endTime.split(':');

                            // Special case: endTime "0:00" means midnight (end of day), treat as 24:00
                            if(endHour === '0' || endHour === '00') {
                                endHour = '24';
                                endMinutes = '0';
                            }

                            // If exception hours are 00:00 to 00:00, it means closed (but we already converted 0:00 end to 24:00)
                            isClosed = startHour === '00' && endHour === '00';

                            GlobalStoreHelper.debug(['=== Exception Day Found ===', {
                                exceptionTitle: holiday.title,
                                exceptionDate: holiday.date,
                                startTime: holiday.startTime,
                                endTime: holiday.endTime,
                                convertedEndHour: endHour,
                                convertedEndMinutes: endMinutes,
                                isFullDayHoliday: holiday.isFullDayHoliday,
                                isClosed
                            }]);
                        }
                    }

                    // If store is not closed entire day then we check the working hours and we are iterating the current day
                    if(!isClosed && i === todayDay) {
                        // Rest an hour from the end hour. Ej: End hour of 22:00 in store selector actually is 21:00 for this check
                        endHour = Number(endHour) - 1;

                        // Check hours
                        const beforeOpening = currentHour < Number(startHour) || (currentHour === Number(startHour) && currentMinutes < Number(startMinutes));
                        const afterOpening = currentHour >= Number(endHour) && currentMinutes > Number(endMinutes);

                        isClosed = beforeOpening || afterOpening;

                        GlobalStoreHelper.debug(['=== Current Day Hours Check ===', {
                            startHour,
                            startMinutes,
                            endHour,
                            endMinutes,
                            currentHour,
                            currentMinutes,
                            beforeOpening,
                            afterOpening,
                            isClosed
                        }]);

                        // If the current day is not closed then no need to check other days
                        if(!isClosed) {
                            minExpressDeliveryDays = -1;

                            continue;
                        }

                        // If is closed because day already finish
                        if(isClosed && afterOpening) {
                            minExpressDeliveryDays ++;

                            continue;
                        }
                    }

                    // If the store is closed, the day is not holiday and will be open soon
                    if(isClosed && i === todayDay && !(startHour === '00' && endHour === '00')) {
                        openSoon = true;
                        continue;
                    }

                    // IF the store is closed any other day
                    if(isClosed) {
                        minExpressDeliveryDays ++;
                    }

                    if(!isClosed) {
                        dayOpenFound = true;
                    }
                }
            }

            // Move Sunday as first item in array because of Javascript /shrug
            holidays.unshift(holidays[holidays.length - 1]);
            holidays.splice(-1);

            GlobalStoreHelper.debug(['=== Store Hours Calculation ===', {
                minExpressDeliveryDays,
                openSoon,
                currentHour,
                currentMinutes,
                holidays,
                storeExceptions
            }]);

            // Create array with holiday exception dates
            const exceptions = onlineLoc?.exceptionDates?.map(exception => {
                return new Date(Date.parse(exception.date)).setUTCHours(0,0,0,0);
            }) || [];

            // Adjust online delivery dates for holidays/exceptions
            let dateOnline = new Date();
            for (let i = 0; i < maxDeliveryOnline; i = i + 1) {
                dateOnline = new Date(dateOnline.setDate(dateOnline.getDate() + 1))
                const day = dateOnline.getUTCDay();

                // Check for holiday or exception
                if (holidays[day] || exceptions.indexOf(dateOnline.setUTCHours(0, 0, 0, 0)) > -1) {
                    maxDeliveryOnline = maxDeliveryOnline + 1;
                    if (i < minDeliveryOnline) {
                        minDeliveryOnline = minDeliveryOnline + 1;
                    }
                }
            }

            // Adjust store delivery dates for holidays/exceptions
            let dateStore = new Date();
            for (let i = 0; i < maxDeliveryStore; i = i + 1) {
                dateStore = new Date(dateStore.setDate(dateStore.getDate() + 1))
                const day = dateStore.getUTCDay();

                // Check for holiday or exception
                if (holidays[day] || exceptions.indexOf(dateStore.setUTCHours(0, 0, 0, 0)) > -1) {
                    maxDeliveryStore = maxDeliveryStore + 1;
                    if (i < minDeliveryStore) {
                        minDeliveryStore = minDeliveryStore + 1;
                    }
                }
            }

            GlobalStoreHelper.debug(['=== Adjusted Delivery Ranges (after holidays) ===', {
                minDeliveryOnline,
                maxDeliveryOnline,
                minDeliveryStore,
                maxDeliveryStore
            }]);

            // Calculate store pickup dates EARLY (needed for CODE 16)
            const dateFromStore = new Date(Date.now() + minDeliveryStore * 24 * 60 * 60 * 1000);
            const dateFromStoreStr = this.formatDate(dateFromStore);

            const dateToStore = new Date(Date.now() + maxDeliveryStore * 24 * 60 * 60 * 1000);
            const dateToStoreStr = this.formatDate(dateToStore);

            GlobalStoreHelper.debug(['=== Store Pickup Dates ===', {
                dateFromStore,
                dateFromStoreStr,
                dateToStore,
                dateToStoreStr
            }]);

            // PRIORITY: If store.deliveryDays is defined, use those specific days
            if(store?.deliveryDays && storeStartDate && storeEndDate) {
                GlobalStoreHelper.debug(['=== CODE 16: store.deliveryDays defined ===', {
                    storeDeliveryDays: store.deliveryDays,
                    storeStartDate,
                    storeEndDate,
                    dateFromStoreStr,
                    dateToStoreStr,
                    promisesKey,
                    longPickupTemplate: window.promises[promisesKey]?.long_pickup,
                    allPromises: window.promises[promisesKey]
                }]);
                results.store = {
                    message: window.promises[promisesKey].long_pickup
                        .replace('{{ date_from }}', options.skipDate ? '' : newLineTag + (options.smallDate ? '<small>' : '') + dateFromStoreStr)
                        .replace('{{ date_to }}', options.skipDate ? '' : dateToStoreStr + (options.smallDate ? '</small>' : ''))
                        .replace(' - ', options.skipDate ? '' : '&nbsp;-&nbsp;') + storeSelectorHtml
                        .trim(),
                    date: dateToStore,
                    color: 'green',
                    code: 16
                };
            }
            // Only use minExpressDeliveryDays logic if store.deliveryDays is NOT defined
            else if((minExpressDeliveryDays > 0 || openSoon) && !store?.deliveryDays) {
                GlobalStoreHelper.debug(['=== CODE 10: Store closed logic ===', {
                    minExpressDeliveryDays,
                    openSoon
                }]);
                // When store is closed, use the minExpressDeliveryDays + store delivery range
                const minDeliveryDate = new Date(new Date()).setDate(new Date().getDate() + minExpressDeliveryDays);
                const fromDate = this.formatDate(minDeliveryDate);
                const dateTo = this.formatDate(new Date(minDeliveryDate.valueOf() + maxDeliveryStore * 24 * 60 * 60 * 1000));

                results.store = {
                    message: window.promises[promisesKey].long_pickup
                        .replace('{{ date_from }}', options.skipDate ? '' : newLineTag + (options.smallDate ? '<small>' : '') + fromDate)
                        .replace('{{ date_to }}', options.skipDate ? '' : dateTo + (options.smallDate ? '</small>' : ''))
                        .replace(' - ', options.skipDate ? '' : '&nbsp;-&nbsp;') + storeSelectorHtml
                        .trim(),
                    date: dateTo,
                    color: 'green',
                    code: 10
                };
            }

            // Calculate online delivery dates
            const dateFromOnline = new Date(Date.now() + minDeliveryOnline * 24 * 60 * 60 * 1000);
            const dateFromOnlineStr = this.formatDate(dateFromOnline);

            const dateToOnline = new Date(Date.now() + maxDeliveryOnline * 24 * 60 * 60 * 1000);
            const dateToOnlineStr = this.formatDate(dateToOnline);

            GlobalStoreHelper.debug(['=== Online Delivery Dates ===', {
                dateFromOnline,
                dateFromOnlineStr,
                dateToOnline,
                dateToOnlineStr
            }]);

            // If item is available in online location or stores can deliver it
            // Backend sets storeDelivery on online location to true, if other locations can fulfill delivery
            if ((online.quantity > 0 || online?.deliverable) || storeDeliveries.length > 0) {
                GlobalStoreHelper.debug(['=== CODE 11: Item available for online delivery ===', {
                    onlineQuantity: online.quantity,
                    onlineDeliverable: online?.deliverable,
                    storeDeliveriesLength: storeDeliveries.length
                }]);
                results.online = {
                    message: window.promises.shipping_available
                        .replace('{{ date_from }}', options.skipDate ? '' : newLineTag + (options.smallDate ? '<small>' : '') + dateFromOnlineStr)
                        .replace('{{ date_to }}', options.skipDate ? '' : dateToOnlineStr + (options.smallDate ? '</small>' : ''))
                        .replace(' - ', options.skipDate ? '' : '&nbsp;-&nbsp;'),
                    date: dateToOnline,
                    color: 'green',
                    code: 11
                };

                if((minExpressDeliveryDays <= 0 && !openSoon) && (locations && locations[options.locationId]?.settings?.receivesCrossStore || options.warehouseTag) && !store?.deliveryDays) {
                    GlobalStoreHelper.debug(['=== CODE 12: Long pickup available ===', {
                        minExpressDeliveryDays,
                        openSoon,
                        receivesCrossStore: locations && locations[options.locationId]?.settings?.receivesCrossStore,
                        warehouseTag: options.warehouseTag,
                        storeDeliveryDays: store?.deliveryDays
                    }]);
                    results.store = {
                        message: window.promises[promisesKey].long_pickup
                        .replace('{{ date_from }}', options.skipDate ? '' : newLineTag + (options.smallDate ? '<small>' : '') + dateFromStoreStr)
                        .replace('{{ date_to }}', options.skipDate ? '' : dateToStoreStr + (options.smallDate ? '</small>' : ''))
                        .replace(' - ', options.skipDate ? '' : '&nbsp;-&nbsp;') + storeSelectorHtml
                        .trim(),
                        date: dateToStore,
                        color: 'green',
                        code: 12
                    };
                }else if(minExpressDeliveryDays <= 0 && !openSoon && !(locations && locations[options.locationId]?.settings?.receivesCrossStore) && options.isModal){
                    GlobalStoreHelper.debug(['=== CODE 13: Only home delivery ===']);
                    results.store = {
                        message: window.promises[promisesKey].only_home_delivery,
                        date: new Date().setFullYear(2100),
                        color: 'orange',
                        code: 13
                    };
                } else {
                    GlobalStoreHelper.debug(['=== No CODE 12 or 13: Conditions not met ===', {
                        minExpressDeliveryDays,
                        openSoon,
                        receivesCrossStore: locations && locations[options.locationId]?.settings?.receivesCrossStore,
                        warehouseTag: options.warehouseTag,
                        isModal: options.isModal
                    }]);
                }
            }

            // If Express Pickup available, overwrite long pickup promise and the product haven't tag "delivery-" (condition: !expressDeliveryDays)
            // BUT: if store.deliveryDays is defined, respect those days and don't show express pickup
            if(
                minExpressDeliveryDays < 0
                && store
                && (!expressDeliveryDays || (options.warehouseTag && !selectedLocationInfo?.wareHouse15))
                && ((!requestedQty && !store.isBackup && store.quantity > 0) || (requestedQty && store.quantity >= requestedQty))
                && !store?.deliveryDays  // Don't override if deliveryDays is defined
            ){
                GlobalStoreHelper.debug(['=== CODE 14: Express pickup ===', {
                    minExpressDeliveryDays,
                    store,
                    expressDeliveryDays,
                    warehouseTag: options.warehouseTag,
                    wareHouse15: selectedLocationInfo?.wareHouse15,
                    requestedQty,
                    storeQuantity: store.quantity,
                    storeIsBackup: store.isBackup,
                    storeDeliveryDays: store?.deliveryDays
                }]);
                results.store = {
                    message: window.promises.express_pickup + storeSelectorHtml,
                    date: new Date(),
                    color: 'green',
                    code: 14
                };
            }

            // If not store selected
            if(!locationId){
                results.store = {
                    message: '',
                    date: null,
                    color: ' ',
                    code: 15
                };
            }

            // If it is still message about availability only in other stores, then modify the output in PDP
            const storeSelector = document.querySelector('.store-location #store-selector');
            const storeName = document.querySelector('.store-location #store-name');
            /* if (storeName && storeSelector) {
                if (results.store.message === window.promises.other_pickup) {
                    storeName.classList.add('d-none');
                    storeSelector.innerHTML = `(${window.promises.check_in_other_stores})`;
                } else {
                    storeName.classList.remove('d-none');
                    storeSelector.innerHTML = Object.keys(locations).length ? `(${window.promises.select_other_location})` : `fffddf(${window.promises.select_your_store_pdp})`;
                }
            } */
        }

        if (options.noEnvioTag) {
            results.online = {
                message: window.promises.no_home_delivery,
                date: null,
                color: 'grey',
                code: 'no_envio'
            };
        }

        GlobalStoreHelper.debug(['=== FINAL RESULTS ===', {
            online: results.online,
            store: results.store
        }]);

        return results;
    }

    static updateStoreInfo(storeInfo) {
        const updateSingleStore = (store) => {
            if (store.name) store.name = store.name.split('(')[0].trim();
            if (store.label) store.label = store.label.split('(')[0].trim();
            if (store.store) store.store = store.store.split('(')[0].trim();
            if (store.settings) store.settings = updateSingleStore(store.settings)
            return store;
        };
        if (Array.isArray(storeInfo)) {
            storeInfo = storeInfo.map(updateSingleStore);
        } else {
            storeInfo = updateSingleStore(storeInfo);
        }
        return storeInfo;
    }

    static getStoreInfo() {
        const locationId = GlobalStoreHelper.getItem('locationId')
        const locations = GlobalStoreHelper.getItem('locations')
        return locationId && locations && locations[locationId] ? this.updateStoreInfo(locations[locationId]) : null;
    }

    static getStoreCode() {
        const store = GlobalStoreHelper.getStoreInfo();
        if(!store) return
        return store && store.code ? store.code : store.name.match(/\((.*?)\)/).length ? store.name.match(/\((.*?)\)/)[1] : null;
    }

    static ifStoreSelected(){
        return GlobalStoreHelper.getItem('locationId') && GlobalStoreHelper.getItem('firstLoadKey') ? true : false;
    }
}
